// Import presets
import { content } from '../../styles/presets';

// Prepare stylesheet
const styles = {
    contentWrapper: { ...content, maxWidth: '1500px' },
    queryPanel: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '15px',
    },
    upgradePanel: {
        display: 'flex',
        alignItems: 'center',
    },
    queryLabel: { marginRight: '10px' },
    queryInput: {
        width: '200px',
        marginRight: '30px',
    },
    querySwitch: {
        marginRight: '30px',
    },
};

export default styles;
